export * from "./scope";
export * from "./faq";
export * from "./location";
export * from "./about";
export * from "./partner";
export * from "./process";
export * from "./testimonials";
export * from "./form";
